<ig-row>
    <ig-col [md]="8">
        <div class="panel">
            <div class="panel-header place-geofence">
                <h1 [class.text-disabled]="searchGeofenceDisabled">Search Geofences</h1>
                <mat-icon tip [class.text-disabled]="searchGeofenceDisabled"
                    matTooltip="Geofences will update events / places on a daily basis">
                    info
                </mat-icon>
                <upgrade-button [show]="searchGeofenceDisabled" [isSimple]="false"
                    [css]="'upgrade-create-place'"></upgrade-button>
            </div>
            <agm-map class="search-geo-map" [latitude]="eventLocation.lat" [longitude]="eventLocation.lng"
                [zoom]="zoom">
                <agm-marker *ngIf="isShowMarker" (markerClick)="locationStatus()" [latitude]="eventLocation.lat"
                    [longitude]="eventLocation.lng">
                    <agm-info-window #infoWindow [isOpen]="true" [maxWidth]="">
                        <div class="map-add-wrap">
                            <p>{{isFeedExisted?'Location Already Added':'Add GPS Location'}}</p>
                            <ig-mat-field label="Display Title" [(ngModel)]="eventLocation.displayTitle"
                                [formControl]="locationFormGroup.get('displayTitle')"></ig-mat-field>
                            <ng-container *ngIf="!isFeedExisted">
                                <mat-checkbox [(ngModel)]="eventLocation.isFilterByCity"
                                    (ngModelChange)="filterPlacesByCity()">Only pull resources in this city
                                </mat-checkbox>
                                <div *ngIf="locationSource==='google'" class="m-t-1">
                                    <hr>
                                    <p>Please select the categories you want to pull, but the more you select, the
                                        slower the pulling will be</p>
                                    <p style="text-align: right;text-decoration: underline;margin-top: 4px;cursor:pointer"
                                        (click)="showCategoryPopup()">Select Categories</p>
                                    <p *ngIf="selectedGoogleCategories&&selectedGoogleCategories.length" class="m-b-1">
                                        Categories you selected:</p>
                                    <span
                                        *ngFor="let type of selectedGoogleCategories;let i = index">{{type.text}}{{i<(selectedGoogleCategories.length-1)?', ':''}}</span>
                                </div>
                            </ng-container>

                                <div *ngIf="isFeedExisted" class="relative">
                                    <div #confirmCheckbox style="position: absolute;top: -27px">
                                        <mat-checkbox [(ngModel)]="isConfirmChecked">I confirm I understand
                                            this:</mat-checkbox>
                                    </div>
                                    <p style="color: #67757c;font-size: 14px;margin: 28px 0 12px 0">If
                                        geofences are deleted, the entire existing database of places will
                                        be deleted, along with the categories and any other promotional
                                        labels such as “Editor’s Choice” etc.</p>
                                </div>

                                <div *ngIf="isFeedExisted">
                                    <ig-button *ngIf="!showSuccessInfo&&!inAddingLocationFeed"
                                        color="accent" class="m-t-1 red-btn" [isAsync]="true" size="md"
                                        (trigger)="addLocation($event)">
                                        REMOVE
                                    </ig-button>
                                    <div class="m-t-1">
                                        <div>Existing categories:</div>
                                        <ng-container
                                            *ngIf="eventLocation&&eventLocation.categories&&eventLocation.categories.length">
                                            <span
                                                *ngFor="let type of eventLocation.categories;let i = index">{{toReadable(type)}}{{i<(eventLocation.categories.length-1)?'
                                            , ':''}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="eventLocation&&eventLocation.categories&&!eventLocation.categories.length">
                                            <span
                                                >Not available</span>
                                        </ng-container>
                                        <hr style="border-style:dashed;border-bottom:none">
                                        <div style="text-align:right;text-decoration:underline;cursor:pointer;" (click)="showCategoryPopup()">Add more categories</div>
                                        <ng-container *ngIf="selectedGoogleCategories.length">
                                            <div>Selected categories:</div>
                                            <span
                                                *ngFor="let type of selectedGoogleCategories;let i = index" 
                                                [ngStyle]="{fontWeight:isCategoryExisting(type.value) ? ' 300': 'bold'
                                            }" matTooltip="{{isCategoryExisting(type.value) ? '' : 'new category'}}">
                                            {{type.text}}{{i<(selectedGoogleCategories.length-1)?', ':''}}</span>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="selectedGoogleCategories.length">
                                        <ig-button *ngIf="!showSuccessInfo&&!inAddingLocationFeed"
                                            color="accent" class="m-t-1" [isAsync]="true" size="md"
                                            (trigger)="addCategoriesToLocation($event)">
                                            PULL THESE NEW CATEGORIES 
                                        </ig-button>
                                        <mat-checkbox class="block" style="margin:4px 0 0 0;float:right;"
                                            [(ngModel)]="isRepullExistingCategories" matTooltip="Re-pull the selected categories which are in the existing list">
                                            Re-pull existing categories</mat-checkbox>
                                </div>

                        </div>

                        <ig-button *ngIf="!showSuccessInfo&&!inAddingLocationFeed&&!isFeedExisted" color="accent"
                            class="m-t-1" [isAsync]="true" size="md" [disabled]="locationFormGroup.invalid"
                            (trigger)="addLocation($event)">
                            ADD
                        </ig-button>
                        <div class="tips" *ngIf="inAddingLocationFeed">
                            <ig-spinner></ig-spinner>
                            <div *ngIf="locationSource===' facebook'">this might take a few
                                                minutes...
                                </div>
                                <div *ngIf="locationSource==='google'">
                                    pulling multiple points, this might take a few minutes... <span
                                        *ngIf="percentage">{{percentage}}</span>
                                </div>
                        </div>
                        <div class="tips" *ngIf="showSuccessInfo">Operation Succeed!</div>
        </div>
        </agm-info-window>
        </agm-marker>
        <agm-circle *ngIf="isShowMarker" [latitude]="eventLocation.lat" [longitude]="eventLocation.lng"
            [radius]="eventLocation.radius*mileToMeters" fillColor="red">
        </agm-circle>
        </agm-map>
        </div>
    </ig-col>
    <ig-col [md]="4">
        <div class="panel fb-place-wrap">
            <div class="panel-header relative">
                <h1 [class.text-disabled]="searchGeofenceDisabled">Search & Add Geofences</h1>
                <mat-icon tip [class.text-disabled]="searchGeofenceDisabled"
                    matTooltip="Geofences will update {{type==='event'?'Eventbrite and Eventful events':'Google places'}} on a daily basis">
                    info
                </mat-icon>
                <upgrade-button [show]="searchGeofenceDisabled" [isSimple]="true"
                    [css]="'upgrade-create-place'"></upgrade-button>
            </div>
            <div class="search-geo-content">
                <ig-address-input #addressInput label="Street, City, State, Zipcode (type and select from the dropdown)"
                    [(ngModel)]="autoCompletedAddress" [isRequired]="true" [disabled]="searchGeofenceDisabled"
                    (ngModelChange)="findOnMap()" [formControl]="locationFormGroup.get('address')">
                </ig-address-input>
                <!--<ig-mat-field-->
                <!--label="Radius (miles)"-->
                <!--type="number"-->
                <!--[maxValue]="30"-->
                <!--[isRequired]="true"-->
                <!--[disabled]="!toggles.placeCalendar&&!toggles.eventByGeolocation"-->
                <!--[(ngModel)]="eventLocation.radius"-->
                <!--[formControl]="locationFormGroup.get('radius')"-->
                <!--&gt;</ig-mat-field>-->
                <ig-field label="Radius (miles)" type="number" [isRequired]="true" [maxValue]="30"
                    [disabled]="searchGeofenceDisabled" [formControl]="locationFormGroup.get('radius')" icon="space_bar"
                    [(ngModel)]="eventLocation.radius">
                </ig-field>

                <ig-select [(ngModel)]="sourceItems" label="source" (itemSelected)="findOnMapBySource($event)"
                    [disabled]="searchGeofenceDisabled"></ig-select>
                <ig-button color="accent" size="md" [disabled]="locationFormGroup.invalid" (trigger)="findOnMap()">
                    FIND ON THE MAP
                </ig-button>
            </div>
        </div>
    </ig-col>
</ig-row>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.geofence/search.geofence.component.html